import { CreditCardHolderDetailsSettings } from './type';

export const creditCardHolderDetailsSettings: CreditCardHolderDetailsSettings =
  {
    componentVariants: {
      variant: {
        prop: 'variant',
        variants: {
          regular: {
            color: 'black.main',
          },
        },
      },
    },
  };
